import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONTEXT } from '../../../utils/workOrderDisplayNumber';

/**
 * Returns work order display context based on hangar product mode.
 * Hangar SKU uses MRO primary key; suite uses CAMO primary key.
 */
export function useWorkOrderDisplayContext() {
  const [context, setContext] = useState(CONTEXT.CAMO);

  useEffect(() => {
    axios.get('/api/mro/hangar-settings')
      .then((res) => {
        const mode = res.data?.productMode || 'SUITE';
        setContext(mode === 'HANGAR' ? CONTEXT.MRO : CONTEXT.CAMO);
      })
      .catch(() => setContext(CONTEXT.CAMO));
  }, []);

  return context;
}
